/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
  GetApiV1PersonPersonidResumeeEnrollmentsPathParams,
  GetApiV1PersonPersonidResumeeEnrollments400,
  GetApiV1PersonPersonidResumeeEnrollments401,
  GetApiV1PersonPersonidResumeeEnrollments500,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeEnrollments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonPersonidResumeeEnrollments } from "../../clients/personResumeeController/getApiV1PersonPersonidResumeeEnrollments.ts";

export const getApiV1PersonPersonidResumeeEnrollmentsQueryKey = (
  personId: GetApiV1PersonPersonidResumeeEnrollmentsPathParams["personId"],
) =>
  [
    {
      url: "/api/v1/person/:personId/resumee/enrollments",
      params: { personId: personId },
    },
  ] as const;

export type GetApiV1PersonPersonidResumeeEnrollmentsQueryKey = ReturnType<
  typeof getApiV1PersonPersonidResumeeEnrollmentsQueryKey
>;

export function getApiV1PersonPersonidResumeeEnrollmentsQueryOptions(
  personId: GetApiV1PersonPersonidResumeeEnrollmentsPathParams["personId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonPersonidResumeeEnrollmentsQueryKey(personId);
  return queryOptions<
    GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonPersonidResumeeEnrollments400
      | GetApiV1PersonPersonidResumeeEnrollments401
      | GetApiV1PersonPersonidResumeeEnrollments500
    >,
    GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
    typeof queryKey
  >({
    enabled: !!personId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonPersonidResumeeEnrollments(personId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados em comum e a lista de matrículas da pessoa **(Requer Authorization para autenticação)**
 * @summary Retorna aba de Matrículas do currículo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:personId/resumee/enrollments}
 */
export function useGetApiV1PersonPersonidResumeeEnrollments<
  TData = GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
  TQueryData = GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonPersonidResumeeEnrollmentsQueryKey,
>(
  personId: GetApiV1PersonPersonidResumeeEnrollmentsPathParams["personId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonPersonidResumeeEnrollments400
          | GetApiV1PersonPersonidResumeeEnrollments401
          | GetApiV1PersonPersonidResumeeEnrollments500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonPersonidResumeeEnrollmentsQueryKey(personId);

  const query = useQuery(
    {
      ...getApiV1PersonPersonidResumeeEnrollmentsQueryOptions(personId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonPersonidResumeeEnrollments400
      | GetApiV1PersonPersonidResumeeEnrollments401
      | GetApiV1PersonPersonidResumeeEnrollments500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
